module.exports = __webpack_public_path__ + "img/credito-agricola.3e4fa662.svg";